/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import MainMenu from "./MainMenu.jsx";
import {UI} from "../UIGenerator.jsx";
import {IoSettingsOutline} from "react-icons/io5";
import ProfileDropdown from "./PageLayout/ProfileDropdown.jsx";
import {ErrorBoundary} from "errorboundarys";
import NotificationIcon from "./Notifications/NotificationIcon.jsx";

function PageLayout(props) {
    return (<div>
        <div className="relative z-10 lg:hidden " role="dialog" aria-modal="true">

            <div className="fixed inset-0 bg-gray-900/80"/>
            <div className="fixed inset-0 flex">
                <div className="relative mr-16 flex w-full max-w-xs flex-1">
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                        <button type="button" className="-m-2.5 p-2.5">
                            <span className="sr-only">Close sidebar</span>
                            <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24"
                                 strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                        </button>
                    </div>
                    {/* Sidebar component, swap this element with another sidebar if you like */}
                    <div className="flex grow flex-col  overflow-y-auto bg-white px-6 pb-4">
                        <div className="flex h-16 shrink-0 items-center cursor-pointer just"
                             onClick={() => {
                                 UI.page().navigate({
                                     pathname: "/"
                                 })
                             }}>
                            <img className="h-8 w-auto"
                                 src="/atagonLogov1.svg"
                                 alt="atagon cloud"/>
                        </div>
                        <nav className="flex flex-1 flex-col">
                            <ErrorBoundary errorStyle={'small'}>
                                <MainMenu/>

                            </ErrorBoundary>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        {/* Static sidebar for desktop */}
        <div className="hidden lg:fixed lg:inset-y-0 lg:z-10 lg:flex lg:w-72 lg:flex-col">
            {/* Sidebar component, swap this element with another sidebar if you like */}
            <div
                className="flex grow flex-col  overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4">
                <div
                    className="flex h-16 shrink-0  cursor-pointer  justify-center transition-colors duration-200 hover:opacity-90"
                    onClick={() => {
                        UI.page().navigate({
                            pathname: "/"
                        })
                    }}>
                    <img className="h-12 mt-1 w-auto"
                         src="/atagonLogov1.svg"
                         alt="atagon cloud"/>
                </div>
                <nav className="flex flex-1 flex-col">
                    <MainMenu/>
                </nav>
            </div>
        </div>
        <div className="lg:pl-72 bg-slate-50 min-h-screen">
            <div className="sticky top-0 z-10">
                <div
                    className="flex h-14 items-center gap-x-4 z-10 border-gray-200  px-4 shadow-sm sm:gap-x-6 lg:shadow-none !py-6 transition backdrop-blur-xs ">
                    <button type="button" className="-m-2.5 p-2.5 text-gray-700 lg:hidden">
                        <span className="sr-only">Open sidebar</span>
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                             stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/>
                        </svg>
                    </button>
                    {/* Separator */}
                    <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
                        <div className={"grow"}>

                        </div>
                        <div className="flex items-center gap-x-5">
                            <NotificationIcon/>

                            <button type="button"
                                    onClick={() => {
                                        UI.page().navigate({
                                            pathname: "/settings"
                                        })
                                    }}
                                    className="-m-2.5 p-2.5 text-gray-400 hover:text-gray-500">
                                <span className="sr-only">View Settings</span>
                                <IoSettingsOutline className="h-6 w-6"/>
                            </button>
                            {/* Separator */}
                            <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
                                 aria-hidden="true"/>
                            {/* Profile dropdown */}
                            <div className="relative">
                                <ProfileDropdown/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <main className="mx-auto max-w-7xl p-5 xl:p-2 ">
                {props.children}
            </main>
        </div>
    </div>);
}

export default PageLayout;